import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components/macro';
import t from 'locales/translation';
import {
  ButtonGroup,
  ButtonPrimary,
  ButtonSecondary,
} from 'app/elements/Buttons';
import { Form } from 'app/elements/Fields/withValidation';
import { Modal } from 'app/components/Modal';
import { H2 } from 'app/components/Typography';
import routeHelpers from 'utils/route-helpers';
import { formDataToObject } from 'utils/form-data';
import { actions } from '../slice';
import { selectIsCreatingEquipmentType } from '../selectors';
import {
  selectSelectedCustomer,
  selectSelectedLocation,
} from 'app/containers/CustomerLocation/selectors';
import EquipmentTypeSelect from 'app/components/EquipmentTypeSelect';

function CreateEquipmentTypeModal() {
  const dispatch = useDispatch();
  const history = useHistory();
  const isCreatingEquipmentType = useSelector(selectIsCreatingEquipmentType);
  const customerId = useSelector(selectSelectedCustomer);
  const locationId = useSelector(selectSelectedLocation);

  const handleClose = () => dispatch(actions.setIsCreatingEquipmentType(false));

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const { miTypeId } = formDataToObject<{ miTypeId: string }>(
      new FormData(e.currentTarget),
    );

    if (!customerId || !locationId || !miTypeId) {
      return;
    }

    history.push(
      routeHelpers.buildEquipmentsRoute(customerId, locationId, miTypeId),
    );

    handleClose();
  };

  if (!isCreatingEquipmentType) {
    return <></>;
  }

  return (
    <Modal onClose={handleClose} withOutsideClose maxWidth={600}>
      <FormStyled onSubmit={handleSubmit}>
        <H2>{t('EquipmentType.AddNew')}</H2>
        {t('EquipmentType.WhatType')}
        <EquipmentTypeSelect required />
        <ButtonGroup>
          <ButtonSecondary type="button" onClick={handleClose}>
            {t('Cancel')}
          </ButtonSecondary>
          <ButtonPrimary type="submit">{t('EquipmentType.Add')}</ButtonPrimary>
        </ButtonGroup>
      </FormStyled>
    </Modal>
  );
}

export const FormStyled = styled(Form)`
  display: flex;
  flex-direction: column;
  gap: 24px;

  > span {
    font-size: ${({ theme }) => theme.fonts.fontSize.ft14};
    color: ${({ theme }) => theme.colors.default.blue2};
  }
`;

export default CreateEquipmentTypeModal;
